module.exports = __webpack_public_path__ + "static/media/sidebar-collapse-left.91467324.svg";